<template>
  <div>
    <h3 class="modal-title"> COMPANY PAYROLL CONFIG </h3>

    <b-form-group :class="{'error-input' : $v.data_payroll.title.$error}">
      <label> Company Payroll Config Title </label>
      <j-input
        v-model="$v.data_payroll.title.$model"
        :max-length="255"
        placeholder="Title"/>
    </b-form-group>
    <b-row>
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closePayroll">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="savePayroll">
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    data_payroll: {
      title: {
        required,
      },
      // payroll: {
      //   required,
      // },
    },
  },
  data() {
    return {
      data_payroll: {
        title: '',
        // payroll: null,
      },
    };
  },
  computed: {
    generateDataPayroll() {
      const data = {
        // value_id: `${this.data_payroll.payroll.id}`,
        value_id: '0',
        pages_id: `${this.dataMaster.pages_id}`,
        name: this.data_payroll.title,
        component_master_id: this.dataMaster.id,
        info: '',
      };
      return data;
    },

    generateDataPayrollUpdate() {
      const data = {
        // value_id: `${this.data_payroll.payroll.id}`,
        value_id: '0',
        pages_id: `${this.dataEdit.pages_id}`,
        name: this.data_payroll.title,
        order: this.dataEdit.order,
        component_master_id: this.dataMaster.id,
        info: '',
      };
      return data;
    },
  },
  mounted() {
    if (this.modeEdit) {
      // this.data_payroll.payroll = {
      //   id: JSON.parse(this.dataEdit.info).id,
      //   name: JSON.parse(this.dataEdit.info).name,
      // };
      this.data_payroll.title = this.dataEdit.name;
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveComponent', 'updateComponent']),

    savePayroll() {
      this.$v.data_payroll.$touch();
      if (!this.$v.data_payroll.$error) {
        if (!this.modeEdit) {
          const dataParam = {
            data: this.generateDataPayroll,
            id: this.dataMaster.id,
          };
          this.saveComponent(dataParam);
        } else {
          const dataParam = {
            data: this.generateDataPayrollUpdate,
            id: this.dataMaster.id,
            component_id: this.dataEdit.id,
          };
          this.updateComponent(dataParam);
        }

        this.closePayroll();
      }
    },

    closePayroll() {
      this.$emit('close-field');
      this.data_payroll.title = '';
      // this.data_payroll.payroll = null;
      setTimeout(() => {
        this.$v.data_payroll.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/pages-component/payroll/jCompanyPayrollSetup.vue